import React, { Component } from 'react';
import styled from 'styled-components';
import Textbox from '@zocdoc-frontend-common/components-textbox';
import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import { blue100 } from '@zocdoc-mezzanine/foundations-colors';
import { labelSmall } from '@zocdoc-mezzanine/foundations-typography';

const referringPhysicianHeader = 'Who is your referring physician?';
const referringPhysicianBody =
    'A referral may be required for your insurance to cover this visit.';

/**
 * @param {function(value: string): void} onReferringPhysicianEntered
 * @param {function(): void} trackSelectReferringPhysician
 * @returns {JSX.Element}
 * @constructor
 */
export class ReferringPhysicianView extends Component {
    renderMessage = () => {
        const { invalidMessage } = this.props;

        if (invalidMessage && invalidMessage.defaultMessage) {
            return invalidMessage.defaultMessage;
        }

        return invalidMessage;
    };

    render() {
        const {
            referringPhysician,
            onReferringPhysicianEntered,
            trimPhysicianValue,
            trackSelectReferringPhysician,
        } = this.props;

        return (
            <FormRow>
                <Label id="referring-physician-label">
                    {referringPhysicianHeader}
                </Label>
                <ReferringPhysician id="referring-physician-description">
                    {referringPhysicianBody}
                </ReferringPhysician>
                <Textbox
                    className="exclude-from-playback"
                    invalidMessage={this.renderMessage()}
                    onBlur={trimPhysicianValue}
                    onChange={(e) =>
                        onReferringPhysicianEntered(e.target.value)
                    }
                    onFocus={trackSelectReferringPhysician}
                    value={referringPhysician}
                    aria-labelledby="referring-physician-label"
                    aria-describedby="referring-physician-description"
                />
            </FormRow>
        );
    }
}

const Label = styled.label`
    ${labelSmall}
    color: ${blue100};
`;

const ReferringPhysician = styled.p`
    ${labelSmall}
    color: ${blue100};
    padding-top: 1px;
    padding-bottom: 3px;
`;
